import {Box, IconButton, Typography} from '@mui/material';
import ArrTooltipWrapper from '../../../components/common/arr-tooltip-wrapper/ArrTooltipWrapper';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const TooltipWrapperDemo: React.FC = () => {
  // Icon color style
  const style = {
    color: '#89A6FF',
  };

  // Common flexbox style for label + icon rows
  const boxStyle = {display: 'flex', alignItems: 'center', gap: '0.5rem'};

  // Sample long tooltip text (will exceed threshold and open in Dialog)
  const shortInfo =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';

  // A reusable group of three "Active Projects" labels each with a tooltip
  const duplicateBox = (
    <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
      {/* First tooltip */}
      <Box sx={boxStyle}>
        <Typography className=" typo-text subhead4_size">
          Active Projects
        </Typography>
        <ArrTooltipWrapper
          title="Active Projects"
          trigger={
            <IconButton aria-label="Info" sx={{padding: 0}}>
              <InfoOutlinedIcon sx={style} fontSize="medium" />
            </IconButton>
          }
        >
          {shortInfo}
        </ArrTooltipWrapper>
      </Box>

      {/* Second tooltip */}
      <Box sx={boxStyle}>
        <Typography className=" typo-text subhead4_size">
          Active Projects
        </Typography>

        <ArrTooltipWrapper
          trigger={
            <IconButton aria-label="Info" sx={{padding: 0}}>
              <InfoOutlinedIcon sx={style} fontSize="medium" />
            </IconButton>
          }
        >
          {shortInfo}
        </ArrTooltipWrapper>
      </Box>

      {/* Third tooltip */}
      <Box sx={boxStyle}>
        <Typography className=" typo-text subhead4_size">
          Active Projects
        </Typography>

        <ArrTooltipWrapper
          trigger={
            <IconButton aria-label="Info" sx={{padding: 0}}>
              <InfoOutlinedIcon sx={style} fontSize="medium" />
            </IconButton>
          }
        >
          {shortInfo}
        </ArrTooltipWrapper>
      </Box>
    </Box>
  );

  return (
    <Box sx={{height: '100vh'}}>
      {/* Page title */}
      <Typography className="typo-text headline1_size">
        ARR Tooltip Wrapper
      </Typography>

      {/* Vertical layout with spaced-out sections */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-around',
          height: '100%',
        }}
      >
        {/* First row of duplicate tooltips */}
        {duplicateBox}

        {/* Second row with custom long tooltip + another tooltip */}
        <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
          {/* Left column: custom tooltip with nested content */}
          <Box sx={boxStyle}>
            <Typography className=" typo-text subhead4_size">
              Active Projects
            </Typography>
            <ArrTooltipWrapper
              title="Active Projects"
              trigger={
                <IconButton aria-label="Info" sx={{padding: 0}}>
                  <InfoOutlinedIcon sx={style} fontSize="medium" />
                </IconButton>
              }
            >
              <>
                {/* Long text content inside tooltip/dialog */}
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
                {/* Nested section with styled title + extra content */}
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: '1rem',
                    gap: '0.25rem',
                  }}
                >
                  <Typography
                    className="typo-text subhead3_size"
                    sx={{color: '#FCFCFD'}}
                  >
                    Title
                  </Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum
                  dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                  tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                  minim veniam, quis nostrud exercitation ullamco laboris nisi
                  ut aliquip ex ea commodo consequat.
                </Box>
              </>
            </ArrTooltipWrapper>
          </Box>

          {/* Right column: tooltip with repeated text */}
          <Box sx={boxStyle}>
            <Typography className=" typo-text subhead4_size">
              Active Projects
            </Typography>

            <ArrTooltipWrapper
              trigger={
                <IconButton aria-label="Info" sx={{padding: 0}}>
                  <InfoOutlinedIcon sx={style} fontSize="medium" />
                </IconButton>
              }
            >
              {shortInfo} {shortInfo.slice(0, 22)}
            </ArrTooltipWrapper>
          </Box>
        </Box>

        {/* Third row of duplicate tooltips */}
        {duplicateBox}
      </Box>
    </Box>
  );
};

export default TooltipWrapperDemo;
